import gql from 'graphql-tag';

export default gql`
  subscription onDeleteItem {
    onDeleteItem {
      id
      title
      price
    }
  }
`;



// WEBPACK FOOTER //
// ./src/app/graphql/subscriptions/DeleteItemSubscription.ts